import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Grid, Label, Button, Form, Dropdown } from "semantic-ui-react";
import { BaseUrl } from "../formcomponents/Constants";
import { renderTextField, renderOptionField } from "../formcomponents";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { BaseUrlInvoice } from "../formcomponents/Constants";
const ExcelUpload = (props) => {
  const [file, setFile] = useState(null);

  const [uploadRes, setuploadRes] = useState("");
  const [isLoading, setisLoading] = useState(0);
  const ticketNumber = [];
  const [formData, setFormData] = useState();
  const [exceltkt, setexceltkt] = useState([]);
  const [excelObjectArr, setexcelObjectArr] = useState([]);
  const [tktCount, settktCount] = useState();
  const [excelData, setExcelData] = useState([]);

  const UPLOAD_ENDPOINT =
    "https://parmartours.com:8443/parmartour/v1.0/getticketinfofromexcel";

  const handleSubmitExcel = async (e) => {
    e.preventDefault();

    setisLoading(1);

    let res = await uploadFile(file);

    console.log(res.data);

    settktCount(res.data.excelTicketList.length);

    let ticketData = res.data.excelTicketList;
    const ticketDataObject = ticketData.map((item, index) => ({
      ordinal: index + 1,
      ticketNumber: item.ticketNumber,
      uploadedDate: "",
      recievedDate: "",
      expiryDate: "",
      sendTo: "",
      remarks: "",
    }));
    setexceltkt(ticketDataObject);
    setisLoading(2);

    // setuploadRes(ticketNumber);
  };

  const [radioButtonValue, setRadioButtonValue] = useState();
  const handleChangeRadio = (e, { value }) => setRadioButtonValue(value);

  const [countOrFromTo, setcountOrFromTo] = useState("count");
  const handleChangeRadioCountOrRange = (e, { value }) =>
    setcountOrFromTo(value);
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const statusVal = [
    { text: "ADULT", value: "ADULT" },
    { text: "CHILD", value: "CHILD" },
  ];

  const [adultOrChild, setAdultOrChild] = useState("");

 
  const updateRecord = (isUploaded) => {
    // e.preventDefault();

    let tempValue = [];

    console.log("Form data", formData);
    const tempCount = formData.count;

    if (countOrFromTo === "count") {
      console.log("exceltkt", exceltkt);

      let lastCheckedIndex = exceltkt.length;

      const firstUnupdatedIndex = exceltkt.findIndex(
        (item) => item.uploaded === false
      );

      console.log("firstUnupdatedIndex", firstUnupdatedIndex);
      lastCheckedIndex =
        firstUnupdatedIndex === -1 ? exceltkt.length : firstUnupdatedIndex;

      // Calculate the last index for updates
      const endIndex = Number(lastCheckedIndex) + Number(tempCount);

      console.log("lastCheckedIndex", lastCheckedIndex);
      console.log("endIndex", endIndex);

      // Update tickets from lastCheckedIndex to endIndex
      const ticketDataObject = exceltkt.map((item, index) => {
        if (index >= lastCheckedIndex && index < endIndex) {
          const newObject = {
            ordinal: index + 1, // Add 1 to start from 1
            ssTicketListId: item.ssTicketListId,
            ticketNumber: item.ticketNumber,
            ssInventoryId: item.ssInventoryId,
            uploadedDate:
              radioButtonValue === "uploadedDate" && formData.uploadedDate
                ? formData.uploadedDate
                : item.uploadedDate,
            uploaded: isUploaded === true && true,
            recievedDate:
              radioButtonValue === "recievedDate" && formData.recievedDate
                ? formData.recievedDate
                : item.recievedDate,
            expiryDate:
              radioButtonValue === "expiryDate" && formData.expiryDate
                ? formData.expiryDate
                : item.expiryDate,
            adultOrChild:
              radioButtonValue === "adultOrChild" && adultOrChild
                ? adultOrChild
                : item.adultOrChild,
            remarks:
              radioButtonValue === "remarks" && formData.remarks
                ? formData.remarks
                : item.remarks,
                sendTo:
                radioButtonValue === "sendTo" && formData.sendTo
                  ? formData.sendTo
                  : item.sendTo,
          };

          tempValue.push({
            ticketNumber: newObject.ticketNumber,
            adultOrChild: newObject.adultOrChild,
          });

          console.log("tempValue", tempValue);
          return newObject; // Return the updated object
        } else {
          // Return the item as is for the rest of the tickets
          return {
            ordinal: index + 1,
            uploaded: item.uploaded,
            ssTicketListId: item.ssTicketListId,
            ssInventoryId: item.ssInventoryId,
            ticketNumber: item.ticketNumber,
            uploadedDate: item.uploadedDate,
            recievedDate: item.recievedDate,
            expiryDate: item.expiryDate,
            adultOrChild: item.adultOrChild,
            sendTo: item.sendTo,
            remarks: item.remarks,
          };
        }
      });

      setexceltkt(ticketDataObject);
      setExcelData(tempValue);
    } else {
      // Handle the other case...
      const ticketDataObject = exceltkt.map((item, index) => {
        if (formData?.form && formData?.to) {
          if (index + 1 >= formData.form && index + 1 <= formData.to) {
            const newObject = {
              ordinal: index + 1,
              ssTicketListId: item.ssTicketListId,
              ticketNumber: item.ticketNumber,
              ssInventoryId: item.ssInventoryId,
              uploadedDate:
                radioButtonValue === "uploadedDate" && formData.uploadedDate
                  ? formData.uploadedDate
                  : item.uploadedDate,
              uploaded:
                radioButtonValue === "uploadedDate" && formData.uploadedDate
                  ? true
                  : item.uploaded,
              recievedDate:
                radioButtonValue === "recievedDate" && formData.recievedDate
                  ? formData.recievedDate
                  : item.recievedDate,
              expiryDate:
                radioButtonValue === "expiryDate" && formData.expiryDate
                  ? formData.expiryDate
                  : item.expiryDate,
              adultOrChild:
                radioButtonValue === "adultOrChild" && adultOrChild
                  ? adultOrChild
                  : item.adultOrChild,
              remarks:
                radioButtonValue === "remarks" && formData.remarks
                  ? formData.remarks
                  : item.remarks,
              sendTo:
                radioButtonValue === "sendTo" && formData.sendTo
                  ? formData.sendTo
                  : item.sendTo,
            };

            tempValue.push({
              ticketNumber: newObject.ticketNumber,
              adultOrChild: newObject.adultOrChild,
            });

            console.log("tempValue", tempValue);
            return newObject;
          } else {
            return {
              ordinal: index + 1,
              uploaded: item.uploaded,
              ssTicketListId: item.ssTicketListId,
              ssInventoryId: item.ssInventoryId,
              ticketNumber: item.ticketNumber,
              uploadedDate: item.uploadedDate,
              recievedDate: item.recievedDate,
              expiryDate: item.expiryDate,
              adultOrChild: item.adultOrChild,
              remarks: item.remarks,
              sendTo: item.sendTo,
            };
          }
        }
        return item; // Fallback to the original item if formData is not defined
      });

      setexceltkt(ticketDataObject);
      setExcelData(tempValue);
    }

    if (isUploaded === true) {
      props.triggerParentMethod();
    }
  };

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    return await axios.post(UPLOAD_ENDPOINT, formData);
  };
  const handleOnChange = (e) => {
    setFile(e.target.files[0]);
  };

  useEffect(() => {
    if (props.ticketList) {
      setexceltkt(props.ticketList);

      // const sortedData = props.ticketList.slice().sort((a, b) => a.ordidelid - b.ordidelid);
      // setFormData(props.ticketList);
    }
  }, [props.ticketList]);

  const { value, onChange } = props;
  // handleSubmitExcel
  props.onChange(exceltkt);
  //props.value(uploadRes);

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData, { skipHeader: true }); // Skip the title row
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
    updateRecord(true);
    // props.triggerParentMethod();
    console.log("Props", props);
  };

  const [searchTicketNumber, setSearchTicketNumber] = useState("");
  const [foundTicketIndex, setFoundTicketIndex] = useState(-1);
  const handleLocalSearch = () => {
    console.log(searchTicketNumber);
    const index = exceltkt.findIndex(
      (item) => item.ticketNumber === searchTicketNumber
    );
    setFoundTicketIndex(index);

    // If the ticket is found, scroll to the corresponding <tr> element
    if (index !== -1) {
      const trElement = document.getElementById(`row-${index}`);
      console.log("trElement:", trElement);
      if (trElement) {
        console.log("Scrolling to:", trElement);
        trElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };

  return (
    <>
      {props.ticketList === undefined && (
        <Grid.Row>
          <Grid columns="three">
            <Grid.Row>
              &nbsp; &nbsp; &nbsp;
              <Label>Select Excel File</Label>
              <Grid.Column>
                {" "}
                <input type="file" onChange={handleOnChange} />
              </Grid.Column>
              <Grid.Column>
                {isLoading === 0 ? (
                  <Button color="primary" onClick={handleSubmitExcel}>
                    Upload Excel
                  </Button>
                ) : isLoading === 1 ? (
                  <div
                    style={{
                      color: "red",
                    }}
                  >
                    Your Ticket is processing, please wait
                  </div>
                ) : (
                  <></>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Row>
      )}

      {exceltkt.length > 0 && (
        <>
          <Form.Field>
            <Grid.Row>
              <Grid columns="six">
                <Grid.Column>
                  <Form.Input
                    name="count"
                    label="Count"
                    type="number"
                    onChange={handleInputChange}
                  />
                </Grid.Column>

                {/* <Grid.Column>
                  <Form.Radio
                    label="Range"
                    name="countOrRange"
                    value="fromTo"
                    checked={countOrFromTo === "fromTo"}
                    onChange={handleChangeRadioCountOrRange}
                  />

                  {countOrFromTo === "fromTo" && (
                    <>
                      <Form.Input
                        name="form"
                        label="From"
                        type="number"
                        onChange={handleInputChange}
                      />

                      <Form.Input
                        name="to"
                        label="To"
                        type="number"
                        onChange={handleInputChange}
                      />
                    </>
                  )}
                </Grid.Column> */}

                <Grid.Column>
                  <Form.Radio
                    label="Adult Or Child"
                    name="radioGroup"
                    value="adultOrChild"
                    checked={radioButtonValue === "adultOrChild"}
                    onChange={handleChangeRadio}
                  />

                  {radioButtonValue === "adultOrChild" && (
                    <Form.Dropdown
                      name="adultOrChild"
                      // label="Adult Or Child"
                      placeholder="Adult Or Child"
                      fluid
                      selection
                      options={statusVal}
                      onChange={(e, data) => setAdultOrChild(data.value)} // Pass the selected value from data
                    />
                  )}
                </Grid.Column>
                <Grid.Column>
                  <Form.Radio
                    label="Upload Date"
                    name="radioGroup"
                    value="uploadedDate"
                    checked={radioButtonValue === "uploadedDate"}
                    onChange={handleChangeRadio}
                  />
                  {radioButtonValue === "uploadedDate" && (
                    <Form.Input
                      name="uploadedDate"
                      // label="Upload"
                      type="date"
                      onChange={handleInputChange}
                    />
                  )}
                </Grid.Column>
                <Grid.Column>
                  <Form.Radio
                    label="Recive Date"
                    name="radioGroup"
                    value="recievedDate"
                    checked={radioButtonValue === "recievedDate"}
                    onChange={handleChangeRadio}
                  />
                  {radioButtonValue === "recievedDate" && (
                    <Form.Input
                      name="recievedDate"
                      // label="Recive Date"
                      type="date"
                      onChange={handleInputChange}
                    />
                  )}
                </Grid.Column>

                <Grid.Column>
                  <Form.Radio
                    label="Remarks"
                    name="radioGroup"
                    value="remarks"
                    checked={radioButtonValue === "remarks"}
                    onChange={handleChangeRadio}
                  />

                  {radioButtonValue === "remarks" && (
                    <Form.Input
                      name="remarks"
                      // label="Remarks"
                      type="text"
                      onChange={handleInputChange}
                    />
                  )}
                </Grid.Column>


                <Grid.Column>
                  <Form.Radio
                    label="Send To"
                    name="radioGroup"
                    value="sendTo"
                    checked={radioButtonValue === "sendTo"}
                    onChange={handleChangeRadio}
                  />

                  {radioButtonValue === "sendTo" && (
                    <Form.Input
                      name="sendTo"
                      // label="Remarks"
                      type="text"
                      onChange={handleInputChange}
                    />
                  )}
                </Grid.Column>
                <Grid.Column>
                  <div
                    style={{
                      marginTop: "20px",
                    }}
                  >
                    <Button positive onClick={(e) => updateRecord(e)}>
                      Update Preview
                    </Button>
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div
                    style={{
                      marginTop: "20px",
                    }}
                  >
                    <Button
                      color="primary"
                      onClick={(e) => exportToCSV(excelData, "Ticket_List")}
                    >
                      Export Excel
                    </Button>
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <Form.Input
                    name="searchTicket"
                    label="Search Ticket"
                    type="text"
                    onChange={(e) => setSearchTicketNumber(e.target.value)}
                  />
                </Grid.Column>
                <Grid.Column>
                  <div
                    style={{
                      marginTop: "20px",
                    }}
                  >
                    <Button color="primary" onClick={handleLocalSearch}>
                      Search
                    </Button>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Row>
          </Form.Field>
          {/* <h1 style={{color:"red"}}>If you export any excel data , must save immedietly</h1> */}

          <table className="ui celled table">
            <thead>
              <tr>
                <th style={{ width: "5%" }}>uploaded</th>
                <th style={{ width: "5%" }}>SR.No</th>
                <th style={{ width: "25%" }}>ticketNumber</th>
                <th style={{ width: "5%" }}>Adult Or Child</th>
                <th style={{ width: "10%" }}>Upload Date</th>
                <th style={{ width: "10%" }}>Recive Date</th>

                <th style={{ width: "20%" }}>Remarks</th>
                <th style={{ width: "20%" }}>Send to</th>
              </tr>
            </thead>
            <tbody>
              {exceltkt.map((item, i) => (
                <tr
                  key={i}
                  id={`row-${i}`}
                  style={{
                    backgroundColor: foundTicketIndex === i ? "yellow" : "",
                  }}
                >
                  <td data-label="Uploaded" style={{ textAlign: "center" }}>
                    {item.uploaded ? (
                      <input
                        type="checkbox"
                        checked
                        style={{ marginLeft: "auto", marginRight: "auto" }}
                      />
                    ) : (
                      <input
                        type="checkbox"
                        style={{ marginLeft: "auto", marginRight: "auto" }}
                      />
                    )}
                  </td>
                  <td data-label="SR.NO">{item.ordinal}</td>
                  <td data-label="Name">{item.ticketNumber}</td>
                  <td data-label="Name">{item.adultOrChild}</td>
                  <td data-label="Name">{item.uploadedDate}</td>
                  <td data-label="Name">{item.recievedDate}</td>
                  <td data-label="Name">{item.remarks}</td>
                  <td data-label="Name">{item.sendTo}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </>
  );
};

const UploadeExcelData = (props) => {
  const {
    placeholder,
    input: { value, onChange },
    disabled,
    triggerParentMethod,
    id,
    ticketList,
  } = props;
  return (
    <ExcelUpload
      id={id}
      triggerParentMethod={triggerParentMethod}
      disabled={disabled}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      ticketList={ticketList}
    />
  );
};

export default UploadeExcelData;
